// import gateManageList from '../components/gateManage/gateManageList.vue'

export default [
    {
        path: 'gateManage/gateManageList',
        component: resolve => require(['@/components/gateManage/gateManageList'],resolve),
        name:"GateManageList",
        meta:{
            id:'858',
            node:'gateManage',
            url:'gateManageList',
        }
    },
    
]


// WEBPACK FOOTER //
// ./src/router/gateManage.js